import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  makeStyles,
  createStyles,
  Button,
  useTheme,
  Badge,
  IconButton,
  Grid,
  Tooltip,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";

import { CustomTheme } from "../../../../types/customTheme";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { layouts } from "chart.js";
import zIndex from "@material-ui/core/styles/zIndex";
import _ from "lodash";
import TextfieldCommon from "../../../../components/textField/TextfieldCommon";

export interface BoxDetailsProps {
  widgetData: any;
}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: theme.palette.background.entity_background,
      borderRadius: 10,
      padding: "0px 20px",
      height: "100%",
      border: `1px solid ${theme.palette.background.entity_border}`,
    },
    rootNormal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "transparent",
      borderRadius: 10,
      padding: "0px 20px",
      height: "100%",
      border: `none`,
    },
    normal: {
      color: theme.palette.custom.orange.contrastText,
      transition: "color 1s ease",
    },
  }),
);

const TextWidgetBox: React.FunctionComponent<BoxDetailsProps> = ({
  widgetData,
}) => {
  const classes = useStyles();

  const handleBoxColor = () => {
    if (widgetData?.data?.main === "headBox") {
      return classes.root;
    } else {
      return classes.rootNormal;
    }
  };

  const theme: CustomTheme = useTheme();
  return (
    <div className={handleBoxColor()}>
      <Grid container>
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
                  justifyContent:
                widgetData?.data?.["align"] === "left"
                  ? "start"
                  : widgetData?.data?.["align"] === "right"
                  ? "end"
                  : "center",
            }}
          >
            <Typography
              variant="h4"
                align={
                  widgetData?.data?.["align"] ? widgetData["align"] : "center"
                }
              style={{
                fontSize: `${
                  widgetData?.data?.["averageTitleFontSize"] ?? 28
                }px`,
                fontWeight: "bold",
              }}
              className={classes.normal}
            >
              {widgetData?.data?.title}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "8px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
                 justifyContent:
                widgetData?.data?.["align"] === "left"
                  ? "start"
                  : widgetData?.data?.["align"] === "right"
                  ? "end"
                  : "center",
              width: "100%",
              zIndex: 0,
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography
                align={
                  widgetData?.data?.["align"] ? widgetData["align"] : "center"
                }
                style={{
                  
                  fontSize: `${
                    widgetData?.data?.["averageSubTitleFontSize"] ?? 12
                  }px`,
                }}
              >
                {widgetData?.data?.subTitle}
              </Typography>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default TextWidgetBox;
